module.exports = __webpack_public_path__ + "static/media/autodrive.20578cfc.gif";